import { hasNativeBridge } from "util/userAgent";
import { deleteToken } from "common/nativeBridge";
import { disconnectAppSocket } from "common/appSocket";

/**
 * ★ 2026-10-30 강제 로그아웃 한 곳 — 한 기기만 로그인(SESSION_REPLACED) · 계정 정지(ACCOUNT_SUSPENDED) · 탈퇴.
 *  들어오는 길: API 인터셉터(401/403 코드), 웹 소켓 'force-logout', 네이티브 소켓이 웹뷰로 보내는 이벤트.
 *  세션을 지우고 안내 문구를 sessionStorage 에 둔 뒤 /login 으로 새로 연다(메모리에 남은 화면·소켓까지 정리).
 *  안내는 ForceLogoutHost 가 열리자마자 한 번 보여 준다. 여러 요청이 동시에 와도 한 번만 처리한다.
 */
export const FORCE_LOGOUT_NOTICE_EVENT = "muyeonForceLogoutNotice";
// 네이티브(iOS FloatingSocketManager·AOS ChatSocketManager)가 소켓으로 받은 강제 로그아웃을 웹뷰에 알리는 이벤트.
export const NATIVE_FORCE_LOGOUT_EVENT = "muyeonNativeForceLogout";
const NOTICE_KEY = "muyeon.logoutNotice";

let handling = false;

export function forceLogout({ code, message } = {}) {
  if (handling) return;
  handling = true;
  try { localStorage.removeItem("muyeonAuth"); } catch {}
  try { sessionStorage.setItem(NOTICE_KEY, JSON.stringify({ code: code || "", message: message || "" })); } catch {}
  disconnectAppSocket();
  // 네이티브 키체인 토큰도 지운다 — 남아 있으면 네이티브 화면(채팅 등)이 끝난 토큰으로 계속 부른다.
  if (hasNativeBridge()) deleteToken().catch(() => {});
  try { window.dispatchEvent(new Event("muyeonForceLogout")); } catch {}
  if (window.location.pathname.startsWith("/login")) {
    // 이미 로그인 화면(정지 회원의 로그인 시도 등) — 새로 열지 않고 안내만.
    handling = false;
    try { window.dispatchEvent(new Event(FORCE_LOGOUT_NOTICE_EVENT)); } catch {}
    return;
  }
  window.location.href = "/login";
}

/** 남겨 둔 안내를 한 번 꺼낸다(없으면 null). */
export function takeLogoutNotice() {
  try {
    const raw = sessionStorage.getItem(NOTICE_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(NOTICE_KEY);
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

// 네이티브가 보낸 강제 로그아웃(detail: { code, message })
if (typeof window !== "undefined") {
  window.addEventListener(NATIVE_FORCE_LOGOUT_EVENT, (e) => forceLogout(e?.detail || {}));
}
